import './recordaudio.css';

import React from 'react';

import MediaRecorder from 'audio-recorder-polyfill';

import MicIcon from '@material-ui/icons/Mic';
import CloseIcon from '@material-ui/icons/Close';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';
import SendIcon from '@material-ui/icons/Send';

import './recordaudio.css';

const MAXSECONDS = 180;

class RecordAudio extends React.Component {
  
  recorder = null;
  state = {
    recordingStatus: null,
    overlayOpened: false,
    audioPlaying: false,
    audioEl: null,
    payloadToSend: null,
    recordingStartTime: null,
    recordingEndTime: null,
    timerInterval: null,
    timer: {seconds: 0, minutes: 0}
  };
  
  constructor(props) {
    super(props);
    this.handleStartRecording = this.handleStartRecording.bind(this);
    this.handleStopRecording = this.handleStopRecording.bind(this);
    this.toggleRecordingOverlay = this.toggleRecordingOverlay.bind(this);
    this.toggleRecordingProcess = this.toggleRecordingProcess.bind(this);
    this.playAudio = this.playAudio.bind(this);
    this.stopAudio = this.stopAudio.bind(this);
    this.onEndedAudio = this.onEndedAudio.bind(this);
    this.sendAudioFile = this.sendAudioFile.bind(this);
  }
  
  handleStartRecording() {
    this.setState({
      recordingStatus: 'loading'
    }, () => {
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
          this.recorder = new MediaRecorder(stream);
      
          this.recorder.addEventListener('dataavailable', e => {
            const fileName = `audioRecording-${Math.round((new Date()).getTime() / 1000)}.wav`;
        
            const audioBlob = new Blob([e.data], { type: 'audio/wav' });
            const audioBlobUrl = URL.createObjectURL(audioBlob);
            const audio = new Audio();
            audio.controls = true;
            audio.src = audioBlobUrl;
            audio.onended = this.onEndedAudio;
        
            this.setState({
              recordingEndTime: new Date(),
              audioEl: audio,
              payloadToSend: {
                formatValue: e.data.type,
                audioFile: new File([e.data], fileName, { type: e.data.type })
              }
            });
          });
      
          let timerInterval = setInterval(() => {
            let current = new Date();
            if (((current.getTime() - this.state.recordingStartTime.getTime())/1000) > MAXSECONDS) {
              this.handleStopRecording();
              return
            }
            let seconds = this.state.timer.seconds;
            let minutes = this.state.timer.minutes;
            seconds++;
            if (seconds >= 60) {
              seconds = 0;
              minutes++;
            }
            this.setState({
              timer: {
                seconds: seconds,
                minutes: minutes
              }
            });
          }, 1000);
      
          // Start recording
          this.recorder.start();
          this.setState({
            recordingStatus: 'started',
            recordingStartTime: new Date(),
            timer: {
              seconds: 0,
              minutes: 0
            },
            timerInterval: timerInterval
          });
        })
        .catch(err => {
          console.error(err);
        });
    });
    
  }
  
  playAudio() {
    this.state.audioEl.play();
    this.setState({
      audioPlaying: true
    })
  }
  
  stopAudio() {
    this.state.audioEl.pause();
    this.state.audioEl.currentTime = 0;
    this.setState({
      audioPlaying: false
    })
  }
  
  onEndedAudio() {
    this.state.audioEl.pause();
    this.state.audioEl.currentTime = 0;
    this.setState({
      audioPlaying: false
    })
  }
  
  sendAudioFile() {
    try {
      if (this.props.dataAvailable) {
        this.props.dataAvailable(this.state.payloadToSend);
      }
      this.toggleRecordingOverlay();
    } catch (err) {
      console.error(err);
    }
    
  }
  
  handleStopRecording() {
    this.recorder.stop();
    // // Remove “recording” icon from browser tab
    this.recorder.stream.getTracks().forEach(i => i.stop());
    
    clearInterval(this.state.timerInterval);
    this.setState({
      recordingStatus: 'stopped',
      timerInterval: null
    });
  }
  
  toggleRecordingProcess() {
    if (this.state.recordingStatus === 'started') {
      this.handleStopRecording();
    } else {
      this.handleStartRecording();
    }
  }
  
  toggleRecordingOverlay() {
    this.setState({
      overlayOpened: !this.state.overlayOpened,
      recordingStatus: null,
      audioPlaying: false,
      audioEl: null,
      payloadToSend: null,
      recordingStartTime: null,
      recordingEndTime: null,
      timerInterval: null,
      timer: {seconds: 0, minutes: 0}
    }, () => {
      if (this.props.expandedCallback) {
        this.props.expandedCallback(this.state.overlayOpened);
      }
    });
  }
  
  render() {
    const {minutes, seconds} = this.state.timer;
    return (
      <div className={'toggleRecordingContainer ' + (this.state.overlayOpened ? ' big' : 'small')}>
        <div className={'expandedControl ' + (this.state.overlayOpened ? 'big' : 'small')}>
          <button className={'recordButton ' + (this.state.recordingStatus === 'started' ? 'blink' : '')}
                  disabled={this.state.recordingStatus === 'loading'}
                  onClick={this.toggleRecordingProcess}>
            <FiberManualRecordIcon fontSize="inherit"/>
          </button>
          <div className={'timer'}>
            {(minutes ? (minutes > 9 ? minutes : "0" + minutes) : "00") + ":" + (seconds > 9 ? seconds : "0" + seconds)}
          </div>
          
          {
            this.state.recordingStatus === 'stopped' ?
              this.state.audioPlaying === false ?
                <button className={'playButton'} onClick={this.playAudio}>
                  <PlayArrowIcon fontSize="inherit"/>
                </button>
                :
                <button className={'stopButton'} onClick={this.stopAudio}>
                  <StopIcon fontSize="inherit"/>
                </button>
              :
              <div className={'flexTemp'}>
                <button className={'playButton'} onClick={this.playAudio}>
                  <PlayArrowIcon fontSize="inherit"/>
                </button>
              </div>
          }
          
          {
            this.state.recordingStatus === 'stopped' ?
              <button className={'sendButton'} onClick={this.sendAudioFile}>
                <SendIcon fontSize="inherit"/>
              </button>
              :
              <div className={'flexTemp'}>
                <button className={'sendButton'}>
                  <SendIcon fontSize="inherit"/>
                </button>
              </div>
          }
          
        </div>
        
        <button onClick={this.toggleRecordingOverlay} className={'toggleRecordingOverlay ' + (this.state.recordingStatus ? this.state.recordingStatus : '')}>
          {
            this.state.overlayOpened ?
              <CloseIcon fontSize="inherit"/>
              :
              <MicIcon fontSize="inherit"/>
          }
        </button>
      </div>
    )
  }
}

export default RecordAudio;
